import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    height: 8,
    width: "100%",
    background: theme.colors.Background5,
    borderRadius: theme.radius.large,
    "&.medium": {
      height: 20,
    },
    "&.small": {
      minWidth: 12,
      height: 12,
    },
  },
  bar: {
    borderRadius: 100,
    boxShadow: `inset 0 0 0 2px ${theme.colors.Border1}`,
    textAlign: "center",
    minWidth: 8,
    "&.medium": {
      minWidth: 16,
      height: 16,
      margin: 2,
    },
    "&.small": {
      minWidth: 8,
      height: 8,
      margin: 1,
    },
  },
}));
